export default {
    en: {
        no_chat: {
            title: "Let's start a chat!",
            desc:
                'Select the chatroom on the left to start chatting with the other member.'
        },
        view_detail: 'View Detail',
        ads_type: {
            property: 'Property',
            project: 'New Properties',
            service: 'Professional Service'
        },
        rent_duration_day: '/Day',
        rent_duration_week: '/Wk',
        rent_duration_month: '/Mth',
        rent_duration_year: '/Yr',
        start_from: 'Start from',
        find_user: 'Find user',
        business_owner: 'owner of {NAME}',
        propertigrab_member: 'member of propertigrab',
        propertigrab_admin_title: 'Admin Propertigrab',
        propertigrab_admin_desc: 'what can we help you with?',
        no_care_chat: {
            title: 'Need our help?',
            desc:
                ' Propertigrab admin will always be ready to help, send us a message from the box below.'
        }
    },
    id: {
        no_chat: {
            title: 'Mari memulai obrolan!',
            desc:
                'Pilih ruang obrolan di samping kiri untuk mulai chat dengan member lain.'
        },
        view_detail: 'Lihat Detail',
        ads_type: {
            property: 'Properti',
            project: 'Properti Baru',
            service: 'Jasa Profesional'
        },
        rent_duration_day: '/Hr',
        rent_duration_week: '/Mgu',
        rent_duration_month: '/Bln',
        rent_duration_year: '/Thn',
        start_from: 'Mulai dari',
        find_user: 'Cari pengguna',
        business_owner: 'pemilik dari {NAME}',
        propertigrab_member: 'pengguna propertigrab',
        propertigrab_admin_title: 'Admin Propertigrab',
        propertigrab_admin_desc: 'ada yang bisa kami bantu?',
        no_care_chat: {
            title: 'Butuh bantuan kami?',
            desc:
                'Admin propertigrab akan selalu siap membantu, kirim pesan ke kami dari kotak di bawah.'
        }
    }
};
